import { useContext } from 'react';
import Task from '../Task';
import {AppContext} from '../../context/AppContext';

const TaskList = (props) => {
    const { state: {taskList}, } = useContext(AppContext);

    const visibleTask = taskList?.filter(el => el.show);
    
    if(visibleTask?.length === 0){
        return <Task noDataAvailable={true} />;
    }
    return (
        <div className="task-list">
            { taskList && taskList?.length ? taskList?.map((todo, index) => {
                return todo.show && <Task {...todo} {...props} taskIndex={index} />;
            }) : <Task noDataAvailabe={true} />}
        </div>
    )
}

export default TaskList;